"use strict";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { useWalletGetCapabilitiesMutation } from "state/walletCapabilities/hooks/useWalletGetCapabilitiesMutation";
import { handleResetWalletCapabilitiesState, selectNeedsToCheckCapabilities } from "state/walletCapabilities/reducer";
import { useEvent } from "utilities/src/react/hooks";
import { useAccount, useAccountEffect } from "wagmi";
export function useWalletCapabilitiesStateEffect() {
  const dispatch = useAppDispatch();
  const { mutate: getCapabilities, isPending: isCheckingCapabilities } = useWalletGetCapabilitiesMutation();
  const needsToCheckCapabilities = useAppSelector(selectNeedsToCheckCapabilities);
  const account = useAccount();
  const onConnect = useEvent(() => {
    if (!isCheckingCapabilities) {
      getCapabilities();
    }
  });
  const onDisconnect = useEvent(() => {
    dispatch(handleResetWalletCapabilitiesState());
  });
  useAccountEffect({
    onConnect,
    onDisconnect
  });
  useEffect(() => {
    if (needsToCheckCapabilities && account.address && !isCheckingCapabilities) {
      getCapabilities();
    }
  }, [needsToCheckCapabilities, account.address, getCapabilities, isCheckingCapabilities]);
}
